import React, { Component } from 'react';
import Header from '../component/header/header';
import GuideTitle from '../component/guide/guideTitle';
import '../component/guide/guide.css';
import { Link } from 'react-router-dom';

class Guide04 extends Component {
    render() {
        const token = JSON.parse(localStorage.getItem("userInfo"));
        const {prePath, nextPath} = this.props.guide;
        return (
            <div className="gudie-wrap time-table-wrap d-flex flex-column">
                <article className="header-wrap"><Header /></article>

                <section className="main-container d-flex flex-column">
                    <GuideTitle guide={this.props.guide} />
                    <div className="body d-flex flex-column align-items-center scroll-wrapper">
                        <div className="container d-flex flex-column align-items-center">
                            <table>
                                <thead>
                                    <tr>
                                        <th>교시</th>
                                        <th>시험과목(문제수)</th>
                                        <th>교시<br/>문제수</th>
                                        <th>시험형식</th>
                                        <th>입실완료시간</th>
                                        <th>시험시간</th>
                                        <th>답안수거시간</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{token[0].test_sec}</td>
                                        <td className="text-left">{token[0].test_name} {token[0].test_count}</td>
                                        <td>{token[0].test_count}</td>
                                        <td>{token[0].type}</td>
                                        <td>{token[0].time1}</td>
                                        <td>{token[0].time2}</td>
                                        <td>5분</td>
                                    </tr>
                                </tbody>
                            </table>
                            <p>* 보건의료인 직종별 예시문항: 보건의료인 직종별 공개 예시문항으로 구성하였습니다.</p>
                        </div>
                    </div>
                </section>
                <footer className="footer-wrap w-100 d-flex justify-content-center align-items-center">
                    <div className="page-btn-wrap d-flex justify-content-center align-content-center">
                        <Link to={prePath}>
                            <button className="btn pre-btn">
                                <span className="icon-wrap">
                                    <svg className="icon pre-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                    </svg>
                                </span>
                                <b>이전</b>
                            </button>
                        </Link>
                        <div className="page-info"><span className="current-page">4</span>&nbsp;/&nbsp;<span className="total-page">5</span></div>
                        <Link to={nextPath}>
                            <button className="btn next-btn">
                                <b>다음</b>
                                <span className="icon-wrap">
                                    <svg className="icon next-icon page-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                        <path className="fill" d="M152.182,127.929a.886.886,0,0,1-.629-.261l-7.111-7.111A.889.889,0,1,1,145.7,119.3l6.483,6.483,6.482-6.483a.889.889,0,0,1,1.257,1.257l-7.111,7.111A.884.884,0,0,1,152.182,127.929Z" transform="translate(-140.182 -111.484)" fill="#999"/>
                                    </svg>
                                </span>
                            </button>
                        </Link>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Guide04;